export function normalizeNullableInteger(value) {
   if (value === '' || value === null || value === undefined) {
      return null;
   }

   const parsed = parseInt(value, 10);
   return Number.isNaN(parsed) ? null : parsed;
}

export function normalizeNullableCents(value) {
   if (value === '' || value === null || value === undefined) {
      return null;
   }

   const parsed = parseFloat(value);
   if (Number.isNaN(parsed)) {
      return null;
   }

   return Math.round(parsed * 100);
}

export function hasValueChanged(nextValue, previousValue) {
   return nextValue !== previousValue;
}
